import { ICustomAnimationProps } from "@thekilroygroup/shared-ui";
import theme from "theme";

export const backgroundAnimations: ICustomAnimationProps = {
  type: "fade",
  delay: 1,
  delayOut: 600,
  timeout: { enter: 1000, exit: 600 },
};

export const searchFormAnimations: ICustomAnimationProps = {
  type: "fade",
  delay: 500,
  delayOut: 200,
  timeout: { enter: 450, exit: 300 },
  easing: {
    enter: theme.transitions.easing.easeIn,
    exit: theme.transitions.easing.easeOut,
  },
};

export const uspAnimations: ICustomAnimationProps = {
  type: "fade",
  delay: 600,
  delayOut: 150,
  timeout: { enter: 350, exit: 300 },
  easing: {
    enter: theme.transitions.easing.easeIn,
    exit: theme.transitions.easing.easeOut,
  },
};

export const navigateDelay = 1000;
